import Skeleton from '../Skeleton'
import styles from './SkeletonCard.module.scss'

export const SkeletonCard = () => {
  return (
    <div className={styles.skeletonCard}>
      <div />
      <div>
        <Skeleton height="20px" width="10ch" />
        <Skeleton height="26px" width="15ch" />
        <Skeleton height="20px" width="20ch" />
        <Skeleton height="20px" width="20ch" />
        <Skeleton height="20px" width="10ch" />
        <Skeleton height="20px" width="10ch" />
      </div>
      <div>
        <Skeleton height="20px" width="10ch" />
        <Skeleton height="20px" width="6ch" />
        <Skeleton height="20px" width="6ch" />
        <Skeleton height="20px" width="10ch" />
        <Skeleton height="20px" width="6ch" />
        <Skeleton height="20px" width="6ch" />
      </div>
    </div>
  )
}
